import { observer } from 'mobx-react';

import { useCoinsAnimation } from '../../../hooks/useCoinsAnimation';
import { useStores } from '../../../stores/useStores';

import { MissionXpGiftAnimation } from './MissionXpGiftAnimation';
import classes from './MissionXpGiftCelebration.module.scss';

export const MissionXpGiftCelebration = observer(() => {
  const { missionsStore, coinTypeStore } = useStores();
  const { startAnimation } = useCoinsAnimation();
  const xpGift = missionsStore.xpGift;

  if (!xpGift?.play) return null;

  return (
    <>
      <div className={classes.backdrop} />
      <MissionXpGiftAnimation
        key={xpGift.boxNum}
        boxNum={xpGift.boxNum}
        onBoxFinish={() => {
          missionsStore.clearXpGift();
        }}
        onBoxOpen={() => {
          setTimeout(() => {
            const gift = missionsStore.xpGift;
            if (!gift) return;
            startAnimation({
              rewards: gift.rewards,
              coinType: coinTypeStore.coinType,
              refetchData: false,
              onEnd: () => missionsStore.clearXpGift(),
            });
          }, 1750);
        }}
      />
    </>
  );
});
